"use client";
import Link from "next/link";
import Image from "next/image";
import { FooterSocialMediaSection } from "@/app/lib/features/footer/footer.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface FooterSocialProps {
  socialMedia: FooterSocialMediaSection;
}

const FooterSocial = ({ socialMedia }: FooterSocialProps) => {
  if (socialMedia.items.length === 0) return null;

  return (
    <div className="space-y-1 lg:space-y-2">
      <h2 className="text-sm sm:text-base lg:text-lg transition-all duration-300 ease-in-out hover:text-main font-medium">
        {socialMedia.title}
      </h2>
      {/* flex-wrap: sütun 5'li grid'de daraldı (xl'de ~165px). 6 ikon tek satırda
          240px istiyor; sarmalanmazsa sütunun dışına taşıyorlardı. */}
      <div className="flex flex-wrap gap-3">
        {socialMedia.items.map((social) =>
          social.url ? (
            <Link
              key={social.key}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGeneric(`social_${social.key}`)}
              className="w-7.5 h-7.5 flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <Image
                src={social.icon}
                alt={social.key}
                width={30}
                height={30}
                className="w-7.5 h-7.5 object-contain"
              />
            </Link>
          ) : (
            <div
              key={social.key}
              className="w-7.5 h-7.5 flex items-center justify-center opacity-40"
            >
              <Image
                src={social.icon}
                alt={social.key}
                width={30}
                height={30}
                className="w-7.5 h-7.5 object-contain"
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default FooterSocial;
